import Marquee from "react-fast-marquee";
import benefitsIcon1 from "../../assets/fellowship/benefits_icon-1.png";
import benefitsIcon2 from "../../assets/fellowship/benefits_icon-2.png";
import benefitsIcon3 from "../../assets/fellowship/benefits_icon-3.png";
import benefitsIcon4 from "../../assets/fellowship/benefits_icon-4.png";
import benefitsIcon5 from "../../assets/fellowship/benefits_icon-5.png";
import benefitsIcon6 from "../../assets/fellowship/benefits_icon-6.png";

const benefits = [
  {
    icon: benefitsIcon1,
    title: "Technical training",
    description: "Gain hands-on innovation and facilitation skills",
  },
  {
    icon: benefitsIcon3,
    title: "Professional growth",
    description: "Develop transferable leadership skills",
  },
  {
    icon: benefitsIcon2,
    title: "Mentorship support",
    description: "Learn from experienced ecosystem leaders",
  },
  {
    icon: benefitsIcon4,
    title: "Resource access",
    description: "Access to tools and experts for growth",
  },
  {
    icon: benefitsIcon5,
    title: "Network building",
    description: "Join a national community of changemakers",
  },
  {
    icon: benefitsIcon6,
    title: "Systemic thinking",
    description: "Solve problems beyond surface symptoms",
  },
];

function FellowshipMarquee() {
  return (
    <Marquee pauseOnHover={true} gradient={false} speed={60} loop={0}>
      {benefits.map((item, idx) => (
        <div key={idx} className="fellowship-marquee-item">
          <img src={item.icon} alt={item.title} className="marquee-item-icon" />
          <div className="marquee-item-card">
            <h4 className="marquee-item-title">{item.title}</h4>
            <p className="marquee-item-desc">{item.description}</p>
          </div>
        </div>
      ))}
    </Marquee>
  );
}

export default FellowshipMarquee;
